export const colors = {
  yellow: {
    name: "Yellow",
    color: "#FDF196",
    darker: "#948D5D",
    lighter: "#EBD429",
  },
  orange: {
    name: "Orange",
    color: "#FBBB75",
    darker: "#916C43",
    lighter: "#E99841",
  },
  beige: {
    name: "Beige",
    color: "#EAC2AD",
    darker: "#877064",
    lighter: "#B98A72",
  },
  pink: {
    name: "Pink",
    color: "#FBD6E7",
    darker: "#917C86",
    lighter: "#E4A1C0",
  },
  coral: {
    name: "Coral",
    color: "#FF9C9C",
    darker: "#945A5A",
    lighter: "#DB4545",
  },
  purpleDirty: {
    name: "Purple dirty",
    color: "#C49CB6",
    darker: "#715A69",
    lighter: "#B16E9A",
  },
  purple: {
    name: "Purple",
    color: "#BEACF9",
    darker: "#6E6390",
    lighter: "#9B86DF",
  },
  blueAqua: {
    name: "Blue aqua",
    color: "#BDF7FD",
    darker: "#6D8F92",
    lighter: "#7BDDE7",
  },
  bluePale: {
    name: "Blue pale",
    color: "#BEEAFF",
    darker: "#6E8794",
    lighter: "#92BFD4",
  },
  blueSky: {
    name: "Blue sky",
    color: "#A0CBFD",
    darker: "#5C7592",
    lighter: "#568CCB",
  },
  turquoise: {
    name: "Turquoise",
    color: "#B9E4E0",
    darker: "#6B8482",
    lighter: "#70BFB8",
  },
  greenPale: {
    name: "Green pale",
    color: "#C3E799",
    darker: "#718658",
    lighter: "#80C333",
  },
  greenOliveDrab: {
    name: "Green olive drab",
    color: "#98B57C",
    darker: "#647157",
    lighter: "#819F65",
  },
  graySilver: {
    name: "Gray silver",
    color: "#DDDDDD",
    darker: "#808080",
    lighter: "#ACACAC",
  },
  gray: {
    name: "Gray",
    color: "#CACACA",
    darker: "#757575",
    lighter: "#7D7D7D",
  },
  greenSuccess: {
    name: "Green success",
    color: "#64CD93",
  },
  redAlert: {
    name: "Red alert",
    color: "#ED6161",
  },
  yellowWarning: {
    name: "Yellow warning",
    color: "#FFCC6B",
  },
};
